import { render, staticRenderFns } from "./orderSetting.vue?vue&type=template&id=013948c8&scoped=true&"
import script from "./orderSetting.vue?vue&type=script&lang=js&"
export * from "./orderSetting.vue?vue&type=script&lang=js&"
import style0 from "./orderSetting.vue?vue&type=style&index=0&id=013948c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013948c8",
  null
  
)

export default component.exports